import React, { useEffect, useState } from "react";
import Actions from "./Actions";
import UsersTable from "./UsersTable";
import CostSection from "./CostSection";
import StatsSection from "./StatsSection";
import Languages from "./Languages";
import { useDispatch } from "react-redux";
import {
  downloadExcelReport,
  fetchLimitedUsers,
  fetchSessionOverview,
  fetchUserCardInfo,
} from "../../requests";
import { startLoader, stopLoader } from "../../_store/reducers/loaderReducer";
import { deleteAuthToken } from "../../utils/helper";
import { DataLoader } from "../common/ResponseLoader";
import _ from "lodash";

const USER_HEADERS = [
  {
    label: "S.No.",
    key: "id",
  },
  {
    label: "User Name",
    key: "user_name",
  },
  {
    label: "Email",
    key: "email",
  },
  {
    label: "Top Session",
    key: "top_session",
  },
  {
    label: "Sessions",
    key: "sessions",
  },
  {
    label: "Language",
    key: "language",
  },
  {
    label: "Date Joined",
    key: "date_joined",
  },
  {
    label: "OpenAI Cost",
    key: "openai_cost",
  },
  {
    label: "Elevenlab Cost",
    key: "elevenlabs_cost",
  },
  {
    label: "AWS Transcribe Cost",
    key: "aws_transcribe_cost",
  },
  {
    label: "Total Spend",
    key: "total_cost",
  },
];

const SESSION_HEADERS = [
  {
    label: "Session Name",
    key: "session_name",
  },
  {
    label: "Unique Users",
    key: "unique_users",
  },
  {
    label: "Avg. Duration",
    key: "avg_duration_minutes",
  },
  {
    label: "Daily Usage",
    key: "daily_usage",
  },
  {
    label: "Monthly Usage",
    key: "monthly_usage",
  },
  {
    label: "Total Cost",
    key: "total_cost",
  },
  {
    label: "Avg. Spend/User",
    key: "avg_spend_per_user",
  },
];

function Index() {
  const [usersData, setUsersData] = useState({
    headers: USER_HEADERS,
    rows: [],
  });
  const [userCardInfo, setUserCardInfo] = useState({
    total_users: 0,
    premium_users: 0,
    new_users_this_month: 0,
    persentage_premium: 0,
  });
  const [loadingUserCardInfo, setLoadingUserCardInfo] = useState(true);
  const [filter, setFilter] = useState({
    filterType: "All",
    startDate: null,
    endDate: null,
  });

  const [sessionsData, setSessionsData] = useState({
    headers: SESSION_HEADERS,
    rows: [],
  });

  const dispatch = useDispatch();

  useEffect(() => {
    fetchTablesData();
    getCardData();
  }, [filter]);

  const getCardData = async () => {
    setLoadingUserCardInfo(true);
    try {
      const req = {
        filter: _.lowerCase(filter?.filterType),
        startDate: filter?.startDate,
        endDate: filter?.endDate,
      };
      console.log(req);
      const response = await fetchUserCardInfo(req);
      setUserCardInfo(response.data);
    } catch (error) {
      if (error?.response?.status === 401) {
        deleteAuthToken();
        window.location.reload();
      }
      console.error("Error in sending message:", error);
    }
    setLoadingUserCardInfo(false);
  };

  const fetchTablesData = async () => {
    dispatch(startLoader());
    try {
      const response = await fetchLimitedUsers({
        filter: _.lowerCase(filter?.filterType),
        startDate: filter?.startDate,
        endDate: filter?.endDate,
      });
      const response2 = await fetchSessionOverview({
        filter: _.lowerCase(filter?.filterType),
        startDate: filter?.startDate,
        endDate: filter?.endDate,
      });
      const rows2 = response2.data.sessions;
      const rows = response.data.users;

      setUsersData({
        headers: USER_HEADERS,
        rows: rows || [],
      });
      setSessionsData({
        headers: SESSION_HEADERS,
        rows: rows2 || [],
      });
    } catch (error) {
      if (error?.response?.status === 401) {
        deleteAuthToken();
        window.location.reload();
      }
      console.error("Error in sending message:", error);
    }

    dispatch(stopLoader());
  };

  const handleDownloadExcel = async () => {
    dispatch(startLoader());
    try {
      const response = await downloadExcelReport({
        filter: _.lowerCase(filter?.filterType),
        startDate: filter?.startDate,
        endDate: filter?.endDate,
      });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const a = document.createElement("a");
      a.href = url;
      a.download = `asksalah_admin_report_${new Date().toISOString()}.xlsx`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      if (error?.response?.status === 401) {
        deleteAuthToken();
        window.location.reload();
      }
      console.error("Error in sending message:", error);
    }
    dispatch(stopLoader());
  };

  const handleFilterChange = (newFilters) => {
    if (newFilters.startDate && !newFilters.endDate) {
      // do nothing
    } else {
      if (newFilters.startDate && newFilters.endDate) {
        newFilters.filterType = "date_range";
      }
      if (["Daily", "Monthly", "All"].includes(newFilters.filterType)) {
        newFilters.startDate = "";
        newFilters.endDate = "";
      }
      setFilter(newFilters);
    }
  };

  return (
    <div className="container">
      <Actions
        onDownloadExcel={handleDownloadExcel}
        onFilterChange={handleFilterChange}
        filter={filter}
      />
      <div className="mt-4">
        {!loadingUserCardInfo ? (
          <StatsSection userCardInfo={userCardInfo} filter={filter} />
        ) : (
          <DataLoader />
        )}
      </div>
      <UsersTable
        headers={usersData.headers}
        rows={usersData.rows}
        tableTitle="Top User Insights"
        variant="blue"
      />
      <UsersTable
        headers={sessionsData.headers}
        rows={sessionsData.rows}
        tableTitle="Session Performance Overview"
        variant="green"
        showViewAll={false}
      />
      <CostSection />
      <Languages />
    </div>
  );
}

export default Index;
